import * as React from 'react';
import * as style from './Seller.css';
import { Logo } from '../Logo';

import { INewbuildingBuilder, ISeller } from '../../../types/newbuilding/builder';
import { isTablet } from '../../../utils/window/isTablet';
import { cropPhone } from '../../../utils/phone/cropPhone';
import { SellerPhone } from '../SellerPhone';

export interface ISellerProps {
  newbuildingId: number;
  siteBlockId?: number | null;
  isAuthenticated?: boolean;
  builderOrSeller: INewbuildingBuilder | ISeller;
  label: string;
  placeType: string;
  trackAction(builderOrSeller: INewbuildingBuilder | ISeller): void;
}
export interface ISellerState {
  isFullPhone: boolean;
}

export class Seller extends React.PureComponent<ISellerProps, ISellerState> {
  public state = { isFullPhone: false };

  public showPhone = async () => {
    this.setState({ isFullPhone: true });
    if (!isTablet()) {
      this.props.trackAction(this.props.builderOrSeller);
    }
  };

  public render() {
    const { builderOrSeller, label, placeType } = this.props;
    const { isFullPhone } = this.state;

    return (
      <div className={style['seller']}>
        <div className={style['seller-logo']}>
          <Logo
            // @ts-ignore
            src={builderOrSeller.logoUrl || builderOrSeller.avatarUrl}
            name={builderOrSeller.name}
          />
        </div>
        <div className={style['seller-info']}>
          <div className={style['seller-title']}>
            <div className={style['seller-name']}>{builderOrSeller.name}</div>
            <div className={style['seller-label']}>{label}</div>
          </div>
          <div>
            {builderOrSeller.phone && (
              <SellerPhone
                isOpen={isFullPhone}
                onClick={this.showPhone}
                phone={cropPhone({ phone: builderOrSeller.phone, isFullPhone: true })}
                blockId={this.props.siteBlockId}
                placeType={placeType}
              >
                {cropPhone({ phone: builderOrSeller.phone, isFullPhone })}
              </SellerPhone>
            )}
          </div>
        </div>
      </div>
    );
  }
}
